import { Button } from "@/components/ui/button";

import { ENTITY_TYPE_LABELS } from "../../constants";
import { ENTITY_TYPES } from "../../constants/entities";
import { EntityTypeToggleProps } from "../../types/entityTypeToggle";

const EntityTypeToggle = (props: EntityTypeToggleProps) => {
  const { entityType, onChange } = props;

  return (
    <div className="grid grid-cols-4 gap-1">
      {ENTITY_TYPES.map((type) => (
        <Button
          key={type}
          variant={entityType === type ? "default" : "outline"}
          size="sm"
          onClick={() => onChange(type)}
        >
          {ENTITY_TYPE_LABELS[type]}
        </Button>
      ))}
    </div>
  );
};

export default EntityTypeToggle;
